import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'enforcementMessage'
	| 'blockedResponseBody'
	| 'blockedResponseBodyResponseBlocked'
	| 'traceId';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		enforcementMessage: {
			id: 'conversation-assistant.guard-block.enforcement-message-nonfinal',
			defaultMessage: 'Blocked by your organization',
			description:
				'Enforcement label shown when a user prompt is blocked by an Atlassian Guard data protection policy.',
		},
		blockedResponseBody: {
			id: 'conversation-assistant.guard-block.blocked-response-body-nonfinal',
			defaultMessage:
				"This prompt was blocked because it may conflict with your organization's AI or data use policies.",
			description:
				'Body text of the blocked assistant response shown when a prompt is blocked by Guard.',
		},
		blockedResponseBodyResponseBlocked: {
			id: 'conversation-assistant.guard-block.blocked-response-body-response-blocked-nonfinal',
			defaultMessage:
				"This response was blocked because it may conflict with your organization's AI or data use policies.",
			description: 'Body text shown when a response (not a prompt) is blocked by Guard.',
		},
		traceId: {
			id: 'conversation-assistant.guard-block.trace-id-nonfinal',
			defaultMessage: 'Trace ID: {traceId}',
			description: 'Trace ID shown in the guard block response for debugging purposes.',
		},
	});

export default message;
